'use client';
import { useEffect } from 'react';
import useThemeStore from '@/store/store.theme';
import { applyTheme, THEME_STORAGE_KEY } from '@/utils/theme';

export default function ThemeEffects() {
  useEffect(() => {
    // Re-read after hydration in case another tab changed the preference after the head script.
    const refresh = () => {
      let dark = document.documentElement.classList.contains('dark');
      try { dark = localStorage.getItem(THEME_STORAGE_KEY) === 'dark'; } catch { /* Keep the applied theme when storage is blocked. */ }
      applyTheme(dark, false);
      useThemeStore.setState({ dark });
    };
    refresh();
    const sync = (event: StorageEvent) => {
      if (event.key !== THEME_STORAGE_KEY && event.key !== null) return;
      const dark = event.key !== null && event.newValue === 'dark';
      applyTheme(dark, false);
      useThemeStore.setState({ dark });
    };
    window.addEventListener('storage', sync);
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, []);
  return null;
}
